import React from "react";
import Directory from "../../component/directory-menu/DirectoryMenu";

import './homepage.styles.scss';


const Homepage = () => (
  <div className="homepage">
    <Directory />
      
  </div>
);

export default Homepage;